<template>
  <div class="od-container" :class="{'px-0': isMobile}" id="gallery">
    <section class="equ_movie">
      <div class="fmovie">
        <youtube :video-id="'tfCupIkZvTo'" :player-vars="playerVars" ref="youtube" :width="408" :height="726" :resize="true"/>
      </div>
    </section>
    <div class="contents">
      <p class="t1">
        오늘하루치과는 환자분이 방문하여 치료가 끝날 때 까지<br/>
        신뢰하는 마음으로 진료를 받으실 수 있게<br/>
        편안한 공간을 준비하였습니다
      </p>
      <ul class="gallerylist">
        <li>
          <img v-lazy="`${publicPath}img/intro/img_gallery02.jpg`">
          <p class="title"><span>치과 입구 전경</span></p>
        </li>
        <li>
          <img v-lazy="`${publicPath}img/intro/img_gallery03.jpg`">
          <p class="title"><span>대기실 전경</span></p>
        </li>
        <li>
          <img v-lazy="`${publicPath}img/intro/img_gallery04.jpg`">
          <p class="title"><span>진료실 전경</span></p>
        </li>
        <li>
          <img v-lazy="`${publicPath}img/intro/img_gallery05.jpg`">
          <p class="title"><span>예진실 전경</span></p>
        </li>
        <li>
          <img v-lazy="`${publicPath}img/intro/img_gallery06.jpg`">
          <p class="title"><span>수술실 전경</span></p>
        </li>
        <li>
          <img v-lazy="`${publicPath}img/intro/img_gallery07.jpg`">
          <p class="title"><span>메이크업룸 전경</span></p>
        </li>
        <li>
          <img v-lazy="`${publicPath}img/intro/img_gallery08.jpg`">
          <p class="title"><span>카페 전경</span></p>
        </li>
        <li>
          <img v-lazy="`${publicPath}img/intro/img_gallery09.jpg`">
          <p class="title"><span>쇼룸 전경</span></p>
        </li>
        <li>
          <img v-lazy="`${publicPath}img/intro/img_gallery10.jpg`">
          <p class="title"><span>상담실 전경</span></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroGallery',
  data() {
    return {
      playerVars: {
        autoplay: 1,
        loop: 1,
        rel: 0,
        controls: 0,
        showinfo: 0,
        playlist: 'tfCupIkZvTo',
      },
    };
  },
  mounted() {
    this.$refs.youtube.player.playVideo();
  },
};
</script>

<style scoped>

</style>
